import { tipsColor } from "constraints/PlanEnum";
import { isEmpty, toInteger } from "lodash";
import DetailModal from "pages/CartPrivate/DetailModal";
import { useCallback, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./Plan.less";
import { getTokenUser } from "commons/apis/authClient";

const TableHeader = (props) => {
  const { length } = props;

  return (
    <thead className="stacking-table-head">
      <tr className="stacking-table-head-row">
        {Array.from({ length }).map((_, index) => (
          <th
            key={index}
            className={`stacking-table-head-cell ${index === 0 ? "fixed" : ""}`}
          >
            <div>
              <p style={{ fontSize: "12px !important" }}>
                {index === 0 ? "" : index}
              </p>
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

const TableCell = (props) => {
  const { item } = props;
  const modalRef = useRef(null);
  const { roleLevel } = getTokenUser();

  const tipColor = useMemo(() => {
    if (roleLevel !== 4 && item.property.status === "Complete") {
      return "#cc0103";
    }

    return item.property.isAcrossFloor
      ? tipsColor[item.property.status]
      : "transparent";
  }, [item, roleLevel]);

  return (
    <>
      {item.property.isAcrossFloor && (
        <div
          className="cell-wrapper-across-ovelay"
          style={{
            backgroundColor: tipColor,
          }}
        />
      )}
      <div
        className={`cell-wrapper ${
          ["InProgress", "Deposited", "Complete"].includes(item.property.status)
            ? "text-white"
            : "text-black"
        } ${item.property.isAcrossFloor ? "cell-wrapper-across" : ""}`}
        onClick={() => modalRef.current.open()}
      >
        {!isEmpty(item.propertyRegisters) && <div className="cell-badge" />}
        <div style={{ fontSize: "12px !important" }} className="cell-item">
          {item?.property?.propertyNo}
        </div>
      </div>
      <DetailModal item={item} ref={modalRef} />
    </>
  );
};

const TableBody = (props) => {
  const { data } = props;
  const { t } = useTranslation();
  const { roleLevel } = getTokenUser();

  const renderTipColor = useCallback(
    (item) => {
      const { property } = item ?? {};
      const { status, isAcrossFloor } = property ?? {};

      if (roleLevel !== 4 && status === "Complete") {
        return "#cc0103";
      }

      return isAcrossFloor ? "transparent" : tipsColor[status];
    },
    [roleLevel]
  );

  return (
    <tbody className="stacking-table-body">
      {data.map((floor) => (
        <tr key={`floor-${floor.index}`} className="stacking-table-body-row">
          <td className="stacking-table-body-cell fixed">
            <div
              style={{
                fontSize: "12px",
              }}
              className="cell-wrapper"
            >
              {t("winners.floor")} {floor.index}
            </div>
          </td>
          {floor.items.map((item, index) => {
            return (
              <td
                key={index}
                className={`stacking-table-body-cell ${!item ? "empty" : ""}`}
                style={{
                  backgroundColor: item ? renderTipColor(item) : "#b2bec3",
                }}
              >
                {item ? (
                  <TableCell item={item} />
                ) : (
                  <div className="cell-wrapper" />
                )}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
};

const CartPlan = (props) => {
  const { plans } = props;
  const { t } = useTranslation();

  const getResponsiveClass = (numberOfApartment) => {
    const numCols = toInteger(numberOfApartment);

    if (numCols <= 3) return "1-3";
    if (numCols <= 10) return "4-10";
    if (numCols <= 20) return "11-20";
    if (numCols <= 50) return "21-50";
    return "50+";
  };

  const responsiveClass = getResponsiveClass(
    toInteger(plans.numberOfApartment)
  );

  return toInteger(plans.numberOfApartment) ? (
    <div
      className={`stacking-container scrollbar`}
      data-columns={responsiveClass}
    >
      <table className="stacking-table">
        <TableHeader length={plans.numberOfApartment + 1} />
        <TableBody data={plans.result} />
      </table>
    </div>
  ) : (
    <div className="parking-container">
      <div className="interaction-overlay">
        <div className="interaction-text">{t("winners.no_data")}</div>
      </div>
    </div>
  );
};

export default CartPlan;
